<template>
  <div class="agentClient">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="form.account" placeholder="交易账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.platform" placeholder="请选择交易平台">
            <el-option
              v-for="item in form.platformData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="form.agentAccount" placeholder="请选择代理账号">
            <el-option
              v-for="item in form.agentAccountData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button @click="changeAgentClientInfo()" type="primary" size="small">{{$t('common.edit')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('common.handle')" width="240">
          <template slot-scope="scope">
            <el-button @click="changeAgentClientInfo(scope.row)" size="mini" type="primary">{{$t('common.edit')}}</el-button>
            <el-button size="mini" type="primary">{{$t('common.delete')}}</el-button>
            <el-button size="mini" type="danger">审批</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="代理客户设置" :visible.sync="isAgentClientPop">
      <el-form label-width="180px">
        <el-form-item label="客户账号">
          <el-input v-model="agentClientForm.account"></el-input>
        </el-form-item>
        <el-form-item label="交易平台">
          <el-select v-model="agentClientForm.platform" placeholder="请选择交易平台">
            <el-option
              v-for="item in agentClientForm.platformData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联代理">
          <el-select v-model="agentClientForm.agentName" placeholder="请选择关联代理">
            <el-option
              v-for="item in agentClientForm.agentNameData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary">{{$t('common.ok')}}</el-button>
        <el-button @click="isAgentClientPop=false">{{$t('common.cancle')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'agentClient',
    data() {
      return {
        form: {
          account: '',
          platform: '',
          platformData: [],
          agentAccount: '',
          agentAccountData: [],
          startTime: new Date(),
          endTime: new Date()
        },
        tableNav: [
          { name: '交易账号', id: 'account' },
          { name: '交易平台', id: 'tradePlatform' },
          { name: '客户姓名', id: 'name' },
          { name: '关联代理代号', id: 'agentAccount' },
          { name: '关联代理名称', id: 'agentName' },
          { name: '开户日期', id: 'ctime' },
          { name: '修改时间', id: 'updateTime' },
          { name: '修改人', id: ' updateName' },
          { name: '审批时间', id: 'auditTime' },
          { name: '审批人', id: 'auditor' },
        ],
        tableData: [{}],
        isAgentClientPop:false,
        agentClientForm:{
          account: '',
          platform: '',
          platformData: [],
          agentName: '',
          agentNameData: [],

        }
      }
    },
    methods:{
      changeAgentClientInfo(obj){
        this.isAgentClientPop = !this.isAgentClientPop
      }
    }
  }
</script>

<style lang="scss" scoped>
  .agentClient {
    margin: 20px;
    .flexCenter {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
